import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 180000,
});

export async function analyzeContract({ contractFile, jaarafrekeningFile, monthlyAmount, yearlyConsumption, hasSolar, postcode }) {
  const formData = new FormData();
  formData.append("contract", contractFile);
  if (jaarafrekeningFile) formData.append("jaarafrekening", jaarafrekeningFile);
  formData.append("monthly_amount", monthlyAmount);
  if (yearlyConsumption !== undefined && yearlyConsumption !== null && yearlyConsumption !== "") {
    formData.append("yearly_consumption_kwh", yearlyConsumption);
  }
  formData.append("has_solar", hasSolar ? "true" : "false");
  if (postcode) formData.append("postcode", postcode);

  const res = await api.post("/analyze", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

export async function getAnalysis(id) {
  const res = await api.get(`/analysis/${id}`);
  return res.data;
}

export function getDocumentDownloadUrl(analysisId, docType) {
  return `${API}/document/${analysisId}/${docType}`;
}

export async function createCheckoutSession(payload) {
  // payload: { analysis_id, package, email, name?, phone?, notes?, origin_url }
  const res = await api.post("/checkout/session", payload);
  return res.data;
}

// ===== Mollie (iDEAL + creditcard voor NL markt) =====
export async function createMolliePayment(payload) {
  // payload: { analysis_id, package, email, name?, phone?, notes?, origin_url, method? }
  // method: "ideal" | "creditcard" | undefined (Mollie shows picker)
  const res = await api.post("/mollie/checkout", payload);
  return res.data;
}

export async function getMolliePaymentStatus(txnId) {
  const res = await api.get(`/mollie/status/${txnId}`);
  return res.data;
}

export async function getCheckoutStatus(sessionId) {
  const res = await api.get(`/checkout/status/${sessionId}`);
  return res.data;
}

export async function submitLawyerLead(payload) {
  // payload: { analysis_id, name, email, phone?, estimated_hours?, urgency?, notes? }
  const res = await api.post("/lawyer-leads", payload);
  return res.data;
}

export async function getPricing() {
  const res = await api.get("/pricing");
  return res.data;
}

export async function getComparisonProviders() {
  const res = await api.get("/comparison/providers");
  return res.data;
}

export async function getComparisonRecommendation(payload) {
  // payload: { analysis_id?, yearly_consumption_kwh?, has_solar?, contract_type?, priority? }
  const res = await api.post("/comparison/recommend", payload || {});
  return res.data;
}

export async function trackComparisonClick({ provider_id, analysis_id }) {
  const res = await api.post("/comparison/click", { provider_id, analysis_id });
  return res.data;
}

// ===== Admin =====
function adminHeaders() {
  const token = localStorage.getItem("admin_token") || "";
  return { Authorization: `Bearer ${token}` };
}

export async function adminLogin(token) {
  const res = await api.post("/admin/auth", { token });
  return res.data;
}

export async function getAdminStats() {
  const res = await api.get("/admin/dashboard/stats", { headers: adminHeaders() });
  return res.data;
}

export async function getAdminClicks(limit = 50) {
  const res = await api.get(`/admin/dashboard/clicks?limit=${limit}`, { headers: adminHeaders() });
  return res.data;
}

export async function getAdminPostbacks(limit = 50) {
  const res = await api.get(`/admin/dashboard/postbacks?limit=${limit}`, { headers: adminHeaders() });
  return res.data;
}

export async function getAdminOrders(limit = 50) {
  const res = await api.get(`/admin/dashboard/orders?limit=${limit}`, { headers: adminHeaders() });
  return res.data;
}

export async function getAdminLeads(limit = 50) {
  const res = await api.get(`/admin/dashboard/leads?limit=${limit}`, { headers: adminHeaders() });
  return res.data;
}

export async function getAdminPostbackUrls() {
  const res = await api.get("/admin/postback-url", { headers: adminHeaders() });
  return res.data;
}

export async function adminSendDailySummary() {
  const res = await api.post("/admin/email/send-daily-summary", {}, { headers: adminHeaders() });
  return res.data;
}

export async function getAdminEmailLog(limit = 20) {
  const res = await api.get(`/admin/email/log?limit=${limit}`, { headers: adminHeaders() });
  return res.data;
}
